import Model from 'src/app/common/model';
import BusinessEntity from './businessEntity.model';
import CustomerDeviceModel from './customerDevice.model';

export default class FarmSiteModel extends Model {
  CustomerDevices: Array<CustomerDeviceModel>;
  bioSecurity: Array<BioSecurity>;
  businessID?: any | BusinessEntity;
  farmNameAtLocation: string;
  waterType: IWaterType;
  soilType: ISoilType;
  address: IAddress;
  contract: Array<Contract>;
  SMEContract: Array<SMEContract>;
  buyerContract: Array<BuyerContract>;
  farmSiteType?: string;
  yearStarted: number;
  ETSOnPremises: boolean;
  labOnPremises: boolean;
  ownership: string;
  numberOfGrowoutPonds: number;
  numberOfNurseries: number;
  totalFarmArea: number;
  waterSpreadArea: number;
  isActive: boolean;
  status: string;
  personType: string;
  chatUserConfig: string;
  buyerUserConfig: string;
  unreadCount?: number;
  results = new Array();
  providerUserConfig = new Array();

  constructor() {
    super();
    this.SMEContract = new Array();
    this.buyerContract = new Array();
    this.contract = new Array();
    this.bioSecurity = new Array();
  }
}

//////////////////////////////
//Address
//////////////////////////////
export class IAddress {
  village?: string;
  mandal?: string;
  taluk?: string;
  state?: string;
  district?: string;
  pincode?: string;
  city?: string;
  latitude?: number;
  longitude?: number;
  country?: string;

  constructor() {
  }
}

//////////////////////////////
//BioSecurity
//////////////////////////////
export class BioSecurity {
  name?: string;

  constructor() {
  }
}

//////////////////////////////
//Contract
//////////////////////////////
export class Contract {
  feedProviderID?: string;
  feedProviderPersonID?: string;
  startDate?: Date | string;
  endDate?: Date | string;
  isCompleted?: boolean;

  constructor() {
  }
}

//////////////////////////////
//SMEContract
//////////////////////////////
export class SMEContract {
  SMEBusinessID?: string;
  SMEPersonID?: string;
  startDate?: Date | string;
  endDate?: Date | string;
  isCompleted?: boolean;

  constructor() {
  }
}

//////////////////////////////
//BuyerContract
//////////////////////////////
export class BuyerContract {
  buyerBusinessID?: string;
  buyerPersonID?: string;
  startDate?: Date | string;
  endDate?: Date | string;
  isCompleted?: boolean;

  constructor() {
  }
}

//////////////////////////////
//IWaterType
//////////////////////////////
export class IWaterType {
  waterTypeId?: number;
  name?: string;

  constructor() {
  }
}

//////////////////////////////
//ISoilType
//////////////////////////////
export class ISoilType {
  soilTypeId?: number;
  name?: string;

  constructor() {
  }
}
